import store from "@/store";

export function hasPermission(permission) {
  const permissions =
    (typeof permission == "string" ? permission.split(",") : permission) || [];
  return store.getters.permissions.some(r => permissions.some(v1 => v1 == r));
}
